import styled from 'styled-components';

export default styled.div`
  background-color: ${({ theme, color }) => theme.color[color]};
  width: 100%;
  height: ${({ theme }) => theme.space[10]};
  margin: ${({ theme }) => theme.space[3]} 0;
  border-radius: ${({ theme }) => theme.borderRadius[1]};
`;
